module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.basicInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.supplier",
      "hasLabel": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.contactInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formContactInformation,
      "translation": "form.supplier",
      "hasLabel": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.AddressInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formAddressInformation,
      "translation": "form.supplier",
      "hasLabel": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cab09b6","hasScoped":false}!./src/app/pages/withNavigation/supplier/quickCreate/quickCreate.html
// module id = 3087
// module chunks = 1